import fetch from './fetchAll'
import Cookies from 'js-cookie'
import { encrypt } from './crypto'

interface RequestOptions {
  withBase?: boolean
  resolveDataData?: boolean
}

function request(url: string, method: string, data?: any, options: RequestOptions = {}) {
  const { withBase = true, resolveDataData = false } = options
  let params = JSON.stringify(
    withBase
      ? {
        base: {
          appid: 'viaimweb',
          cver: '1.0.0',
          token: Cookies.get('token') ?? '',
          osid: 'web',
          ua: navigator.userAgent
        },
        param: data
      }
      : {
        param: data
      }
  )
  if (method !== 'post_no_crypto') params = encrypt(params, 'z8uil4vz' + url?.split('&v=1.0&t=')[1].slice(-8))

  switch (method) {
    case 'get':
      return fetch({
        method: 'get',
        url,
        crypto: true,
        resolveDataData,
        params: data
      })
    case 'post':
      return fetch({
        method: 'post',
        url,
        crypto: true,
        resolveDataData,
        data: params
      })
    case 'post_no_crypto':
      return fetch({
        method: 'post',
        url,
        crypto: false,
        resolveDataData,
        data: params
      })
    default:
      return fetch
  }
}

export default request
